import { render } from "./AlertsByN.vue?vue&type=template&id=975b316e"
import script from "./AlertsByN.vue?vue&type=script&lang=js"
export * from "./AlertsByN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__